import api, { IResponse } from "./http-common";
import { ECode } from "ztypes/error-code";

class HomeService {
  upgrateZba = async (encryptGroupId: string | null) => {
    const res = await api.post<IResponse>(`/upgrade-zba`, {
      params: { gid: encryptGroupId },
    });
    if (res && res.status == 200) {
      return res.data;
    }
    return null;
  };

  upgrateCommunity = async (encryptGroupId: string | null) => {
    const res = await api.post<IResponse>(`/upgrade-community`, null, {
      params: { gid: encryptGroupId },
    });
    if (res && res.data?.error_code === ECode.SUCCESS) {
      return res.data;
    }
    return null;
  };
}

export default new HomeService();
